import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Categorías", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Servicios", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Usuarios", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Empresas", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Ciudades", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Especialistas", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Operadores", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Perfiles de seguridad", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createBlock(_component_ion_menu, { "content-id": "main-content" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/categories"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.apps
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/servicios"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.construct
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/usuarios"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.people
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/empresas"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.business
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/ciudades"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.businessOutline
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/especialistas"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.personAdd
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/operadores"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.people
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            button: "",
            lines: "none",
            "router-link": "/dashboard/perfiles-seguridad"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                class: "ml-2 mr-4",
                icon: _ctx.key
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_text, null, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}